<div class="street-light-planner-step4">
  <p class="label question">
    {{ 'module.energyMap.streetlightPlanner.step4Questiontext' | translate }}
  </p>
  <div class="choices">
    <button class="btn btn-primary -border-inverted btn-yes" [class.-active]="isReused === true" (click)="select(true)">
      {{ 'module.energyMap.streetlightPlanner.step4Yes' | translate }}
    </button>
    <button class="btn btn-primary -border-inverted btn-no" [class.-active]="isReused === false" (click)="select(false)">
      {{ 'module.energyMap.streetlightPlanner.step4No' | translate }}
    </button>
  </div>
</div>
